export interface TestableComponentProps {
    'data-testid'?: string;
}

export type Comment = {
    id: string;
    name: string;
    date: string;
    comment: string;
};

export interface CollapsableEditModeI {
    isEditing: boolean;
    editedCommentId: string;
}

export type CollapsableSize = 'compact' | 'large';

export type CommentStatus = 'open' | 'resolved';
